import { useMemo } from 'react';

import { getIgnoredFieldsFromLogicJumps } from 'constants/logic';

import { QuestionResponse } from './QuestionResponse/QuestionResponse';

// Normalize field id to string for answer lookup so logic jump evaluation and display
// stay consistent whether API/form use numeric or string ids.
const answerKey = id => String(id);

export const FormResponse = ({ form, answers, flagSeverities, params = {} }) => {
  const fields = useMemo(() => {
    if (!form || !answers) return [];

    const maxOrder = form.fields?.length > 0 ? Math.max(...form.fields.map(f => f.order)) : null;
    const ignoredFields = getIgnoredFieldsFromLogicJumps(
      form.logic_jumps,
      form.fields,
      id => answers[answerKey(id)],
      maxOrder,
    );

    return form.fields.filter(field => !ignoredFields.includes(field.order));
  }, [form, answers]);

  return (
    <div className="bg-slate-50 flex flex-col gap-8 p-8">
      {fields.map((field, index) => (
        <QuestionResponse
          key={field.id}
          order={index + 1}
          field={field}
          answer={answers[answerKey(field.id)]}
          flagSeverity={flagSeverities?.[answerKey(field.id)]}
          params={params}
        />
      ))}
    </div>
  );
};
